import React from "react";

import Head from "../../../components/Head";
import { HOST_URL } from "../../../config/constants";
import Base from "../../../layouts/Base";
import UnsubscribePage from "../../../components/Unsubscribe";

export default function Subcribe(props) {
  return (
    <Base {...props}>
      <Head>
        <title>Show Schedule - Real America's Voice News</title>
        <meta
          name="description"
          content="Real America's Voice News is your one stop news and entertainment network."
        />
        <meta
          name="og:title"
          content="Show Schedule - Real America's Voice News"
        />
        <meta
          name="og:description"
          content="Real America's Voice News is your one stop news and entertainment network."
        />
        <link rel="canonical" href={`${HOST_URL}/show-schedule/`} />
      </Head>
      <UnsubscribePage />
    </Base>
  );
}

export async function getServerSideProps() {
  const apiPrivateUrl = process.env.apiPrivateUrl;

  try {
    const apiEndpoints = [
      `${apiPrivateUrl}/widgets/sidebar`,
      `${apiPrivateUrl}/menu/footer`,
    ];

    const [sidebar, footerMenu] = await Promise.all(
      apiEndpoints.map((endpoint) =>
        fetch(endpoint)
          .then((response) => response.json())
          .catch((err) => console.log(err))
      )
    );

    return {
      props: {
        widgets: {
          "content-top": [],
          top: [],
          "content-bottom": [],
          sidebar,
        },
        footerMenu,
        headerType: "default",
      },
    };
  } catch (e) {
    console.group("pages/unsubscribe/[hash]/[email].jsx - getServerSideProps");
    console.log(e);
    console.groupEnd();

    return {
      notFound: true,
    };
  }
}
